module.exports = __webpack_public_path__ + "static/img/mennaan-piiloon.c077243.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mennaan-piiloon.jpeg
// module id = xanr
// module chunks = 1